/** @format */

import {
  ColorMap,
  FontMap,
  Theme,
  Font,
  backgroundColorMap,
  ButtonColorMap,
  typographyMap,
} from "../types/themes";
import { mq } from "./themeBreakpoint";
import {
  BodyBg,
  ColorDark,
  ColorError,
  ColorInfo,
  ColorInverse,
  ColorLight,
  ColorPrimary,
  ColorPrimaryContrast,
  ColorSecondary,
  ColorSuccess,
  ColorTertiary,
  ColorWarning,
  DesignColorCombination,
  SelectedBg,
  SelectedHoverBg,
  SelectedHoverBorder,
  White,
  Button,
  LoginButton,
  AffBlue,
  AffBlueGrad,
  LoginImageBackground,
  LoginHeader,
  LoginLabelText,
  DashboardBackground,
  DashboardBorder,
  DashboardHeadTypo,
  DashboardSearchPlaceholderTypo,
  SuccessTagBorder,
  SuccessTagBackground,
  SuccessTagTextColor,
  ErrorTagBorder,
  ErrorTagBackground,
  ErrorTagTextColor,
  WarningTagBorder,
  WarningTagBackground,
  WarningTagTextColor,
  ActionTextTypo,
  DashboardPaginationBorder,
  AccordianBorder,
  AccordianBackground,
  BackButtonBGColor,
  PDFViewerColor,
  PDFViewerBorder,
  DashboardTableCellBorder,
  DropdownBackground,
  DropdownBorder,
  UploadDragBackground,
  AppTitle,
  Green,
  Orange,
  Red,
  Blue,
  DarkGreen,
  GridHeaderBackground,
  HighlightPDFBorder,
  HighlightPDFBorderRemove,
  HighlightPDF,
  HighlightPDFRemove,
} from "./themeVariable";

const defaultBackgroundColors: backgroundColorMap = {
  themeMode: "light",
  default: BodyBg,
  paper: "#01203a, #0358a0",
  componentText: "black",
  componentBgColor: "#ffffff",
  componentHoverBorder: "#BCBCBC",
  componentBorderColor: SelectedBg,
};

const defaultBackgroundColorsDark: backgroundColorMap = {
  themeMode: "dark",
  default: "#121212",
  paper: "#333333",
  componentText: "white",
  componentBgColor: "#333333",
  componentHoverBorder: "#5E5E5E",
  componentBorderColor: SelectedBg,
};
const ButtonColor: ButtonColorMap = {
  borderColor: SelectedBg,
  hover: {
    borderColor: SelectedHoverBorder,
    background: SelectedHoverBg,
    hoverText: ColorDark,
  },
  before: {
    borderColor: SelectedBg,
    background: SelectedBg,
  },
  active: {
    borderColor: SelectedBg,
    background: SelectedBg,
  },
};

const defaultColors: ColorMap = {
  primary: ColorPrimary,
  secondary: ColorSecondary,
  tertiary: ColorTertiary,
  info: ColorInfo,
  success: ColorSuccess,
  warning: ColorWarning,
  error: ColorError,
  dark: ColorDark,
  light: ColorLight,
  inverse: ColorInverse,
  designColor: DesignColorCombination,
  white: White,
  button: Button,
  loginButton: LoginButton,
  affBlue: AffBlue,
  affBlueGrad: AffBlueGrad,
  loginImageBackground: LoginImageBackground,
  loginHeader: LoginHeader,
  loginLabelText: LoginLabelText,
  dashboardBackground: DashboardBackground,
  dashboardBorder: DashboardBorder,
  dashboardHeadTypo: DashboardHeadTypo,
  dashboardSearchPlaceholderTypo: DashboardSearchPlaceholderTypo,
  successTagBackground: SuccessTagBackground,
  successTagBorder: SuccessTagBorder,
  successTagTextColor: SuccessTagTextColor,
  errorTagBorder: ErrorTagBorder,
  errorTagBackground: ErrorTagBackground,
  errorTagTextColor: ErrorTagTextColor,
  warningTagBackground: WarningTagBackground,
  warningTagBorder: WarningTagBorder,
  warningTagTextColor: WarningTagTextColor,
  actionTextTypo: ActionTextTypo,
  dashboardPaginationBorder: DashboardPaginationBorder,
  accordianBorder: AccordianBorder,
  accordianBackground: AccordianBackground,
  backButtonBGColor: BackButtonBGColor,
  pDFViewerColor: PDFViewerColor,
  pDFViewerBorder: PDFViewerBorder,
  dashboardTableCellBorder: DashboardTableCellBorder,
  dropdownBackground: DropdownBackground,
  dropdownBorder: DropdownBorder,
  uploadDragBackground: UploadDragBackground,
  appTitle: AppTitle,
  green: Green,
  orange: Orange,
  red: Red,
  blue: Blue,
  darkGreen: DarkGreen,
  gridHeaderBackground: GridHeaderBackground,
  highlightPDFRemove: HighlightPDFRemove,
  highlightPDF: HighlightPDF,
  highlightPDFBorder: HighlightPDFBorder,
  highlightPDFBorderRemove: HighlightPDFBorderRemove,
};

const typography: typographyMap = {
  fontcolor: ColorPrimaryContrast,
};

export const Default: Theme = {
  colors: defaultColors,
  background: defaultBackgroundColors,
  ButtonColor: ButtonColor,
  typography: typography,
  breakpoints: mq,
};

export const Dark: Theme = {
  colors: defaultColors,
  background: defaultBackgroundColorsDark,
  ButtonColor: ButtonColor,
  typography: typography,
  breakpoints: mq,
};

const defaultFonts: FontMap = {
  fontSizes: {},
  fontWeights: {},
  fontColor: {},
};

const mediumFonts: FontMap = {
  fontSizes: {},
  fontWeights: {},
  fontColor: {},
};

const largeFonts: FontMap = {
  fontSizes: {},
  fontWeights: {},
  fontColor: {},
};

export const defaultFont: Font = {
  fontConfig: defaultFonts,
};

export const mediumFont: Font = {
  fontConfig: mediumFonts,
};

export const largeFont: Font = {
  fontConfig: largeFonts,
};
